import createAsyncAction from "../../utils/asyncAction";
import * as api from "../api/grievance/grievance_api";
import * as types from "../constants/grievance_constants";

const getUserGrievancesTypes = {
  success: types.GET_USER_GRIEVANCES_SUCCESS,
  failure: types.GET_USER_GRIEVANCES_FAILURE,
};

const getSingleGrievanceTypes = {
  success: types.GET_SINGLE_GRIEVANCE_SUCCESS,
  failure: types.GET_SINGLE_GRIEVANCE_FAILURE,
};

export const getUserGrievances = createAsyncAction(
  api.getUserGrievances,
  getUserGrievancesTypes,
);

export const getSingleGrievance = createAsyncAction(
  api.getSingleGrievance,
  getSingleGrievanceTypes,
);

export const createGrievance = (values) => async (dispatch) => {
  try {
    const response = await api.createGrievance(values);
    const { error, data } = response;

    if (error) {
      dispatch({ type: types.CREATE_GRIEVANCE_FAILURE, payload: error });
      return null;
    }

    dispatch({ type: types.CREATE_GRIEVANCE_SUCCESS, payload: data });
    return data?.grievance || null;
  } catch (error) {
    dispatch({
      type: types.CREATE_GRIEVANCE_FAILURE,
      payload: error.message,
    });
    return null;
  }
};

export const uploadGrievanceAttachment = (id, formData) => async (dispatch) => {
  try {
    const response = await api.uploadGrievanceAttachment(id, formData);
    const { error, data } = response;

    if (error) {
      dispatch({
        type: types.UPLOAD_GRIEVANCE_ATTACHMENT_FAILURE,
        payload: error,
      });
      return null;
    }

    dispatch({
      type: types.UPLOAD_GRIEVANCE_ATTACHMENT_SUCCESS,
      payload: data,
    });

    return data?.grievance || null;
  } catch (error) {
    dispatch({
      type: types.UPLOAD_GRIEVANCE_ATTACHMENT_FAILURE,
      payload: error.message,
    });
    return null;
  }
};
